export const NODE_NAME = 'webbookmark';
